import React, { useContext, useEffect } from 'react'; //eslint-disable-line
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';

import locationStoreContext from '../stores/locationStore';
import viewStoreContext from '../stores/viewStore';
import StationHeader from '../components/StationHeader';
import TripDirectionHeader from '../components/TripDirectionHeader';
import goTrackerConfig from 'goTrackerConfig';
import * as CONSTS from '../utils/constants';
import '../i18n';
import HeaderColumns from '../components/HeaderColumns';
import UnionDepartureRows from '../components/UnionDepartureRows';

const UnionDeparture = observer(props => {
  const { t } = useTranslation();

  const headerCol = [
    t('unionDepartures.columnHeadings.1'),
    t('unionDepartures.columnHeadings.2'),
    t('unionDepartures.columnHeadings.3'),
    t('unionDepartures.columnHeadings.4')
  ];

  // const location = useLocation();
  const locationStore = useContext(locationStoreContext);
  const viewStore = useContext(viewStoreContext);

  const loadPage = () => {
    if (!props.station || !props.corridor) return;

    locationStore.setCorridor(props.corridor);
    locationStore.setStation(props.station);
    locationStore.loadTripsByCorridorAndStation();

    if (!locationStore.station) return;

    if (locationStore.station.hasBus) {
      locationStore.loadUnionBusTrainDepartures(locationStore.station.code, locationStore.station.timingPoint);
    } else {
      locationStore.loadUnionDepartures();
    }
  };

  useEffect(() => {
    viewStore.updateView(CONSTS.VIEW_PATHS.UNION_DEPARTURE);
  }, []);

  useEffect(() => {
    loadPage();

    const interval = setInterval(() => {
      locationStore.loadTripsByCorridorAndStation();
      if (locationStore.station?.hasBus) {
        locationStore.loadUnionBusTrainDepartures(locationStore.station.code, locationStore.station.timingPoint);
      } else {
        locationStore.loadUnionDepartures();
      }

      if (goTrackerConfig.debug) {
        viewStore.updateAutoRefreshTime();
      }
    }, goTrackerConfig.autoRefreshRate || 10000);

    return () => clearInterval(interval);
  }, [locationStore.corridors]);

  const stationName = locationStore.station ? locationStore.station.name : '';
  const getPath = trip => {
    return trip.serviceType === CONSTS.SERVICE_TRAIN ? {
      pathname: `${viewStore.views.unionDeparture}/${props.corridor}/${props.station}/${viewStore.views.tripDetail}/${trip.number}`,
      state: {
        direction: CONSTS.SERVICE_DIRECTION_OUTBOUND,
        isLoaded: true,
        coachCount: trip.coachCount,
        scheduledCoachCount: trip.scheduledCoachCount
      }
    } : {
      pathname: `${viewStore.views.busDeparture}/${props.corridor}/${props.station}/${viewStore.views.busTripDetail}/${trip.number}`,
      state: {},
    };
  };
  const UnionDepartureIcon = name => <>{CONSTS.STATION_NAME_UNION}<i className="fas fa-arrow-right" />{name}</>;

  return (
    <main id="main-content">
      <div className="selection">
        <StationHeader stationName={UnionDepartureIcon(stationName)} isTrain={true} isBus={locationStore.station?.hasBus} />
        <TripDirectionHeader direction={CONSTS.SERVICE_DIRECTION_OUTBOUND} />
        <HeaderColumns className="departure-header-row union" headerCol={headerCol} />
        {locationStore.isUnionDepartureLoaded ? (
          <UnionDepartureRows
            stationName={stationName}
            trips={locationStore.unionDepartureTrips}
            onGetPath={getPath}
            onResetTripDetail={locationStore.resetTripDetail}
            isTwentyFourHour={viewStore.isTwentyFourHour}
            isLanguageFrench={viewStore.language === CONSTS.FR.CODE}
          />
        ) : (
          <div className="departure-row no-trip"><i className="fa fa-spinner fa-spin" /></div>
        )}
      </div>
    </main>
  );
});

export default UnionDeparture;
